// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3m1C9","emails":"CreateEditClinics_emails__1uqQz","emailTagLabel":"CreateEditClinics_emailTagLabel__2zx8x"};